import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './RMCRules.css';

// Регламент на итальянском: чемпионат итальянский, и участникам из Италии
// удобнее читать правила на родном языке. Ниже переводы на остальные языки
// интерфейса, для языков без перевода — английский текст
const RMCRulesContentIt = () => (
  <div className="rmc-rules-content">

    <section>
      <h2>1. INTRODUZIONE</h2>
      <p>Il Rouvy Mamiky's Championship (RMC) è una competizione di ciclismo indoor che si svolge sulla piattaforma virtuale Rouvy, rivolta ad amatori e appassionati di tutto il mondo. Il campionato si svolge dal 2 novembre 2026 al 31 marzo 2027 con l'obiettivo di promuovere lo sport attraverso l'uso di tecnologie immersive e di favorire l'interazione tra i partecipanti con competizioni settimanali che garantiscono libertà di partecipazione e inclusione.</p>

      <h3>Requisiti di iscrizione:</h3>
      <p>Per partecipare è necessario:</p>
      <p><strong>Richiesta di amicizia su Rouvy:</strong> ogni corridore deve inviare o confermare una richiesta di collegamento a mamiky su Rouvy, per consentire il monitoraggio e l'elaborazione dei dati di gara.</p>
    </section>

    <section>
      <h2>2. STRUTTURA DEL CAMPIONATO</h2>

      <h3>2.1. Durata:</h3>
      <p>Dal 2 novembre 2026 al 28 marzo 2027</p>
      <p>L'intero Campionato è suddiviso in quattro gare mensili, con percorsi specifici per ciascuna gara (Trentino Marathon…Slovenia Marathon…), con classifiche di categoria e generali per queste quattro gare e una speciale classifica finale dell'intero RMC, riservata a chi partecipa a tutte le gare mensili.</p>

      <h3>2.2. Come partecipare alle gare:</h3>
      <p><strong>Gare settimanali ufficiali:</strong></p>
      <p>Ogni settimana si svolgono due gare ufficiali:</p>
      <ul>
        <li><strong>Mercoledì:</strong> alle 08:15, 12:15, 16:15, 18:15, 20:15 CET</li>
        <li><strong>Giovedì:</strong> alle 08:45, 12:45, 16:45, 18:45, 20:45 CET</li>
      </ul>

      <h3>2.3. Formato della competizione:</h3>
      <p><strong>Categorie di gara:</strong></p>
      <p>Le gare si svolgeranno su percorsi AR (Realtà Aumentata) e non AR, con o senza scia (scia consentita o meno). Ogni specifica sarà comunicata in anticipo nel calendario delle gare.</p>
      <p>Oltre alle gare individuali, saranno organizzate Cronometro a Squadre (con scia) e Cronometro Individuali (senza scia).</p>

      <p><strong>Bici ammesse:</strong></p>
      <ul>
        <li>Nelle gare ufficiali sono ammesse solo bici da strada (le bici da cronometro saranno sostituite automaticamente).</li>
        <li>Nelle cronometro senza scia sono ammesse le bici da cronometro.</li>
        <li>La modalità "JUST RIDE" è severamente vietata durante le gare.</li>
      </ul>

      <h3>2.4. Wild Card:</h3>
      <p>Ogni corridore ha a disposizione 5 Wild Card durante il Campionato, utilizzabili per creare una Gara Extra, con data e ora a sua scelta, in base alle proprie esigenze.</p>
    </section>

    <section>
      <h2>3. CLASSIFICHE</h2>

      <h3>3.1. Classifica generale:</h3>
      <p>Classifica a punti.</p>

      <h3>3.2. Classifiche di categoria:</h3>
      <p>La classificazione e la valutazione della Categoria (W/kg) si baseranno sul calcolo della media dei Watt/kg, relativa esclusivamente alle Gare di Test di Novembre (Trentino Marathon) e ad alcune che si svolgeranno senza scia o in modalità non AR.</p>

      <div className="rmc-categories-table">
        <table>
          <thead>
            <tr><th>Categoria</th><th>W/kg</th></tr>
          </thead>
          <tbody>
            <tr><td>ELITE</td><td>≥ 4.7</td></tr>
            <tr><td>A1</td><td>≥ 4.4</td></tr>
            <tr><td>A2</td><td>≥ 4.1</td></tr>
            <tr><td>A3</td><td>≥ 3.8</td></tr>
            <tr><td>A4</td><td>≥ 3.5</td></tr>
            <tr><td>A5</td><td>≥ 3.2</td></tr>
            <tr><td>A6</td><td>≥ 2.9</td></tr>
            <tr><td>A7</td><td>≥ 2.6</td></tr>
            <tr><td>A8</td><td>≥ 2.3</td></tr>
            <tr><td>A9</td><td>&lt; 2.3</td></tr>
          </tbody>
        </table>
      </div>
      <p><em>* Gli atleti che superano una media di 5 W/kg saranno esclusi dalle classifiche.</em></p>

      <h3>Categorie d'età:</h3>
      <div className="rmc-age-categories">
        <div className="rmc-age-col">
          <h4>UOMINI</h4>
          <ul>
            <li>M1: 17–29 anni</li>
            <li>M2: 30–39 anni</li>
            <li>M3: 40–49 anni</li>
            <li>M4: 50–59 anni</li>
            <li>M5: 60–64 anni</li>
            <li>M6: 65–69 anni</li>
            <li>M7: 70–74 anni</li>
            <li>M8: 75+ anni</li>
          </ul>
        </div>
        <div className="rmc-age-col">
          <h4>DONNE</h4>
          <ul>
            <li>W1: 17–29 anni</li>
            <li>W2: 30–44 anni</li>
            <li>W3: 45–59 anni</li>
            <li>W4: 60+ anni</li>
          </ul>
        </div>
      </div>
    </section>

    <section>
      <h2>4. REGOLAMENTO TECNICO</h2>

      <h3>4.1. Rulli smart di Classe A (ammessi per tutte le categorie):</h3>
      <ul>
        <li><strong>Van Rysel:</strong> RCR</li>
        <li><strong>Wahoo:</strong> Kickr V5, Kickr V6, Kickr Move, Kickr Bike V1, Kickr Bike V2, Kickr Bike Shift, Kickr Core</li>
        <li><strong>Tacx:</strong> Neo, Neo 2T, Neo 3M, Neo Bike, Neo Bike Plus</li>
        <li><strong>Elite:</strong> Justo, Justo 2, Direto X, Direto XR, Direto XR-T, Avanti</li>
        <li><strong>Thinkrider:</strong> X7 pro, X2, X2 Max</li>
        <li><strong>Cycplus:</strong> T2, T7</li>
        <li><strong>APX:</strong> APX Pro, APXComp</li>
        <li><strong>Zycle:</strong> Zbike 2.0</li>
        <li><strong>WattBike Atom</strong></li>
      </ul>

      <h3>Rulli smart di Classe B (ammessi per le categorie da A5 ad A9):</h3>
      <p>Tutti i rulli di Classe A elencati sopra, più:</p>
      <ul>
        <li><strong>Tacx:</strong> Flux-S, Flux 2</li>
        <li><strong>Elite:</strong> Suito, Suito-T, Rampa, Rivo</li>
        <li><strong>Jet Black:</strong> Volt</li>
        <li><strong>ZDrive</strong></li>
      </ul>
      <p>Eventuali altri rulli devono essere comunicati all'organizzatore per la valutazione dell'idoneità prima dell'inizio del campionato.</p>

      <h3>Accessori obbligatori:</h3>
      <ul>
        <li>Sensore di cadenza</li>
        <li>Cardiofrequenzimetro</li>
        <li>Misuratore di potenza derivante esclusivamente dal rullo e non da altre fonti esterne (Stages, pedali, QZ App, ecc.), pena l'esclusione del partecipante dall'RMC.</li>
      </ul>

      <h3>4.2. Impostazioni e configurazione:</h3>
      <ul>
        <li><strong>Difficoltà:</strong> i rulli devono essere impostati al 100% di difficoltà.</li>
        <li><strong>Firmware aggiornato:</strong> è obbligatorio avere l'ultima versione ufficiale rilasciata (non beta).</li>
        <li><strong>Cambio di attrezzatura:</strong> i partecipanti devono comunicare qualsiasi cambio di attrezzatura con almeno 5 giorni di anticipo.</li>
      </ul>
      <p>In caso di problemi con il cardiofrequenzimetro, l'app o il rullo durante la gara, occorre segnalarlo all'organizzatore prima della stesura delle classifiche.</p>
    </section>

    <section>
      <h2>5. PENALITÀ</h2>

      <h3>Comportamenti vietati e possibili violazioni:</h3>
      <ul>
        <li>Manomissione di dati o dispositivi (ad es. altezza/peso falsificati)</li>
        <li>Uso di attrezzatura non conforme o non approvata</li>
        <li>Mancato utilizzo del cardiofrequenzimetro</li>
        <li>Prestazioni non verificabili</li>
      </ul>

      <h3>Tipi di penalità:</h3>
      <ul>
        <li><strong>Prima violazione:</strong> penalità di tempo</li>
        <li><strong>Seconda violazione:</strong> esclusione dalla gara in corso</li>
        <li><strong>Terza violazione:</strong> squalifica dal campionato</li>
      </ul>
    </section>

    <section>
      <h2>6. NOTE FINALI</h2>
      <p><strong>Controlli incrociati:</strong> gli organizzatori possono richiedere dati esterni (come BikeCalculator) per verificare prestazioni anomale.</p>
      <p><strong>Community interattiva:</strong> si consiglia di unirsi ai gruppi ufficiali Facebook e Telegram per ricevere aggiornamenti in tempo reale.</p>
    </section>

  </div>
);

// Регламент на немецком — для участников из немецкоязычных стран
const RMCRulesContentDe = () => (
  <div className="rmc-rules-content">

    <section>
      <h2>1. EINLEITUNG</h2>
      <p>Die Rouvy Mamiky's Championship (RMC) ist ein Indoor-Radsportwettbewerb auf der virtuellen Plattform Rouvy, der sich an Amateure und Radsportbegeisterte aus aller Welt richtet. Die Meisterschaft findet vom 2. November 2026 bis zum 31. März 2027 statt. Ziel ist es, den Sport durch immersive Technologien zu fördern und den Austausch unter den Teilnehmern durch wöchentliche Wettbewerbe zu stärken, die freie Teilnahme und Inklusion gewährleisten.</p>

      <h3>Voraussetzungen für die Anmeldung:</h3>
      <p>Für die Teilnahme ist Folgendes erforderlich:</p>
      <p><strong>Freundschaftsanfrage auf Rouvy:</strong> Jeder Fahrer muss mamiky auf Rouvy eine Verbindungsanfrage senden oder dessen Anfrage bestätigen, damit die Renndaten erfasst und ausgewertet werden können.</p>
    </section>

    <section>
      <h2>2. AUFBAU DER MEISTERSCHAFT</h2>

      <h3>2.1. Dauer:</h3>
      <p>Vom 2. November 2026 bis zum 28. März 2027</p>
      <p>Die gesamte Meisterschaft ist in vier monatliche Rennen mit jeweils eigenen Strecken unterteilt (Trentino Marathon…Slovenia Marathon…). Für diese vier Rennen gibt es Kategorie- und Gesamtwertungen sowie eine spezielle Abschlusswertung der gesamten RMC, die denjenigen vorbehalten ist, die an allen monatlichen Rennen teilnehmen.</p>

      <h3>2.2. Teilnahme an den Rennen:</h3>
      <p><strong>Offizielle wöchentliche Rennen:</strong></p>
      <p>Jede Woche finden zwei offizielle Rennen statt:</p>
      <ul>
        <li><strong>Mittwoch:</strong> um 08:15, 12:15, 16:15, 18:15, 20:15 MEZ</li>
        <li><strong>Donnerstag:</strong> um 08:45, 12:45, 16:45, 18:45, 20:45 MEZ</li>
      </ul>

      <h3>2.3. Wettbewerbsformat:</h3>
      <p><strong>Rennkategorien:</strong></p>
      <p>Die Rennen werden auf AR-Strecken (Augmented Reality) und Nicht-AR-Strecken ausgetragen, mit oder ohne Windschatten (Windschattenfahren erlaubt oder nicht). Die jeweiligen Vorgaben werden vorab im Rennkalender bekannt gegeben.</p>
      <p>Neben den Einzelrennen werden Mannschaftszeitfahren (mit Windschatten) und Einzelzeitfahren (ohne Windschatten) organisiert.</p>

      <p><strong>Zugelassene Räder:</strong></p>
      <ul>
        <li>In offiziellen Rennen sind nur Rennräder zugelassen (Zeitfahrräder werden automatisch ersetzt).</li>
        <li>In Zeitfahren ohne Windschatten sind Zeitfahrräder zugelassen.</li>
        <li>Der Modus „JUST RIDE“ ist während der Rennen strengstens verboten.</li>
      </ul>

      <h3>2.4. Wildcards:</h3>
      <p>Jeder Fahrer hat während der Meisterschaft 5 Wildcards zur Verfügung. Mit ihnen kann er ein Zusatzrennen zu einem Datum und einer Uhrzeit seiner Wahl anlegen, je nach seinen Bedürfnissen.</p>
    </section>

    <section>
      <h2>3. WERTUNGEN</h2>

      <h3>3.1. Gesamtwertung:</h3>
      <p>Punktewertung.</p>

      <h3>3.2. Kategoriewertungen:</h3>
      <p>Die Einstufung und Bewertung der Kategorie (W/kg) basiert auf dem durchschnittlichen Watt/kg-Wert, der ausschließlich aus den Testrennen im November (Trentino Marathon) sowie einigen Rennen ohne Windschatten oder im Nicht-AR-Modus berechnet wird.</p>

      <div className="rmc-categories-table">
        <table>
          <thead>
            <tr><th>Kategorie</th><th>W/kg</th></tr>
          </thead>
          <tbody>
            <tr><td>ELITE</td><td>≥ 4.7</td></tr>
            <tr><td>A1</td><td>≥ 4.4</td></tr>
            <tr><td>A2</td><td>≥ 4.1</td></tr>
            <tr><td>A3</td><td>≥ 3.8</td></tr>
            <tr><td>A4</td><td>≥ 3.5</td></tr>
            <tr><td>A5</td><td>≥ 3.2</td></tr>
            <tr><td>A6</td><td>≥ 2.9</td></tr>
            <tr><td>A7</td><td>≥ 2.6</td></tr>
            <tr><td>A8</td><td>≥ 2.3</td></tr>
            <tr><td>A9</td><td>&lt; 2.3</td></tr>
          </tbody>
        </table>
      </div>
      <p><em>* Athleten mit einem Durchschnitt von mehr als 5 W/kg werden aus den Wertungen ausgeschlossen.</em></p>

      <h3>Altersklassen:</h3>
      <div className="rmc-age-categories">
        <div className="rmc-age-col">
          <h4>MÄNNER</h4>
          <ul>
            <li>M1: 17–29 Jahre</li>
            <li>M2: 30–39 Jahre</li>
            <li>M3: 40–49 Jahre</li>
            <li>M4: 50–59 Jahre</li>
            <li>M5: 60–64 Jahre</li>
            <li>M6: 65–69 Jahre</li>
            <li>M7: 70–74 Jahre</li>
            <li>M8: 75+ Jahre</li>
          </ul>
        </div>
        <div className="rmc-age-col">
          <h4>FRAUEN</h4>
          <ul>
            <li>W1: 17–29 Jahre</li>
            <li>W2: 30–44 Jahre</li>
            <li>W3: 45–59 Jahre</li>
            <li>W4: 60+ Jahre</li>
          </ul>
        </div>
      </div>
    </section>

    <section>
      <h2>4. TECHNISCHES REGLEMENT</h2>

      <h3>4.1. Smarttrainer der Klasse A (für alle Kategorien zugelassen):</h3>
      <ul>
        <li><strong>Van Rysel:</strong> RCR</li>
        <li><strong>Wahoo:</strong> Kickr V5, Kickr V6, Kickr Move, Kickr Bike V1, Kickr Bike V2, Kickr Bike Shift, Kickr Core</li>
        <li><strong>Tacx:</strong> Neo, Neo 2T, Neo 3M, Neo Bike, Neo Bike Plus</li>
        <li><strong>Elite:</strong> Justo, Justo 2, Direto X, Direto XR, Direto XR-T, Avanti</li>
        <li><strong>Thinkrider:</strong> X7 pro, X2, X2 Max</li>
        <li><strong>Cycplus:</strong> T2, T7</li>
        <li><strong>APX:</strong> APX Pro, APXComp</li>
        <li><strong>Zycle:</strong> Zbike 2.0</li>
        <li><strong>WattBike Atom</strong></li>
      </ul>

      <h3>Smarttrainer der Klasse B (für die Kategorien A5 bis A9 zugelassen):</h3>
      <p>Alle oben aufgeführten Trainer der Klasse A sowie:</p>
      <ul>
        <li><strong>Tacx:</strong> Flux-S, Flux 2</li>
        <li><strong>Elite:</strong> Suito, Suito-T, Rampa, Rivo</li>
        <li><strong>Jet Black:</strong> Volt</li>
        <li><strong>ZDrive</strong></li>
      </ul>
      <p>Andere Trainer müssen dem Organisator vor Beginn der Meisterschaft zur Prüfung der Zulassung gemeldet werden.</p>

      <h3>Pflichtzubehör:</h3>
      <ul>
        <li>Trittfrequenzsensor</li>
        <li>Herzfrequenzmesser</li>
        <li>Die Leistungsmessung muss ausschließlich über den Trainer erfolgen und nicht über andere externe Quellen (Stages, Pedale, QZ App usw.), andernfalls wird der Teilnehmer von der RMC ausgeschlossen.</li>
      </ul>

      <h3>4.2. Einstellungen und Konfiguration:</h3>
      <ul>
        <li><strong>Schwierigkeit:</strong> Die Trainer müssen auf 100 % Schwierigkeit eingestellt sein.</li>
        <li><strong>Aktuelle Firmware:</strong> Die neueste offiziell veröffentlichte Version (keine Beta) ist Pflicht.</li>
        <li><strong>Wechsel der Ausrüstung:</strong> Teilnehmer müssen jeden Wechsel der Ausrüstung mindestens 5 Tage im Voraus melden.</li>
      </ul>
      <p>Treten während des Rennens Probleme mit dem Herzfrequenzmesser, der App oder dem Trainer auf, müssen diese dem Organisator vor der Erstellung der Wertungen gemeldet werden.</p>
    </section>

    <section>
      <h2>5. STRAFEN</h2>

      <h3>Verbotenes Verhalten und mögliche Verstöße:</h3>
      <ul>
        <li>Manipulation von Daten oder Geräten (z. B. gefälschte Größe/Gewicht)</li>
        <li>Verwendung nicht konformer oder nicht zugelassener Ausrüstung</li>
        <li>Fahren ohne Herzfrequenzmesser</li>
        <li>Nicht überprüfbare Leistungen</li>
      </ul>

      <h3>Arten von Strafen:</h3>
      <ul>
        <li><strong>Erster Verstoß:</strong> Zeitstrafe</li>
        <li><strong>Zweiter Verstoß:</strong> Ausschluss aus dem laufenden Rennen</li>
        <li><strong>Dritter Verstoß:</strong> Disqualifikation von der Meisterschaft</li>
      </ul>
    </section>

    <section>
      <h2>6. SCHLUSSBEMERKUNGEN</h2>
      <p><strong>Gegenprüfungen:</strong> Die Organisatoren können externe Daten (z. B. BikeCalculator) anfordern, um auffällige Leistungen zu überprüfen.</p>
      <p><strong>Interaktive Community:</strong> Wir empfehlen, den offiziellen Facebook- und Telegram-Gruppen beizutreten, um Neuigkeiten in Echtzeit zu erhalten.</p>
    </section>

  </div>
);

// Регламент на испанском: те же разделы, что в остальных переводах
const RMCRulesContentEs = () => (
  <div className="rmc-rules-content">

    <section>
      <h2>1. INTRODUCCIÓN</h2>
      <p>El Rouvy Mamiky's Championship (RMC) es una competición de ciclismo indoor que se disputa en la plataforma virtual Rouvy y está dirigida a aficionados y entusiastas de todo el mundo. El campeonato se celebra del 2 de noviembre de 2026 al 31 de marzo de 2027 con el objetivo de promover el deporte mediante tecnologías inmersivas y de fomentar la relación entre los participantes con competiciones semanales que garantizan libertad de participación e inclusión.</p>

      <h3>Requisitos de inscripción:</h3>
      <p>Para participar hace falta:</p>
      <p><strong>Solicitud de amistad en Rouvy:</strong> cada ciclista debe enviar o confirmar una solicitud de conexión con mamiky en Rouvy, para permitir el seguimiento y el tratamiento de los datos de carrera.</p>
    </section>

    <section>
      <h2>2. ESTRUCTURA DEL CAMPEONATO</h2>

      <h3>2.1. Duración:</h3>
      <p>Del 2 de noviembre de 2026 al 28 de marzo de 2027</p>
      <p>Todo el campeonato se divide en cuatro carreras mensuales, con recorridos propios de cada carrera (Trentino Marathon…Slovenia Marathon…), con clasificaciones por categoría y generales de esas cuatro carreras y una clasificación final especial de toda la RMC, reservada a quienes participen en todas las carreras mensuales.</p>

      <h3>2.2. Cómo participar en las carreras:</h3>
      <p><strong>Carreras semanales oficiales:</strong></p>
      <p>Cada semana se disputan dos carreras oficiales:</p>
      <ul>
        <li><strong>Miércoles:</strong> a las 08:15, 12:15, 16:15, 18:15 y 20:15 CET</li>
        <li><strong>Jueves:</strong> a las 08:45, 12:45, 16:45, 18:45 y 20:45 CET</li>
      </ul>

      <h3>2.3. Formato de competición:</h3>
      <p><strong>Categorías de carrera:</strong></p>
      <p>Las carreras se disputarán en recorridos AR (realidad aumentada) y no AR, con o sin rebufo (permitido o no). Cada particularidad se anunciará con antelación en el calendario de carreras.</p>
      <p>Además de las carreras individuales, se organizarán contrarrelojes por equipos (con rebufo) y contrarrelojes individuales (sin rebufo).</p>

      <p><strong>Bicicletas admitidas:</strong></p>
      <ul>
        <li>En las carreras oficiales solo se permiten bicicletas de carretera (las de contrarreloj se sustituyen automáticamente).</li>
        <li>En las contrarrelojes sin rebufo sí se permiten las bicicletas de contrarreloj.</li>
        <li>El modo «JUST RIDE» está terminantemente prohibido durante las carreras.</li>
      </ul>

      <h3>2.4. Wild cards:</h3>
      <p>Cada ciclista dispone de 5 wild cards durante el campeonato, que puede usar para crear una carrera extra en la fecha y la hora que prefiera, según le convenga.</p>
    </section>

    <section>
      <h2>3. CLASIFICACIONES</h2>

      <h3>3.1. Clasificación general:</h3>
      <p>Clasificación por puntos.</p>

      <h3>3.2. Clasificaciones por categoría:</h3>
      <p>La clasificación y la asignación de categoría (W/kg) se basarán en el cálculo de los vatios/kg medios, tomados exclusivamente de las carreras de prueba de noviembre (Trentino Marathon) y de algunas que se disputarán sin rebufo o en modo no AR.</p>

      <div className="rmc-categories-table">
        <table>
          <thead>
            <tr><th>Categoría</th><th>W/kg</th></tr>
          </thead>
          <tbody>
            <tr><td>ELITE</td><td>≥ 4,7</td></tr>
            <tr><td>A1</td><td>≥ 4,4</td></tr>
            <tr><td>A2</td><td>≥ 4,1</td></tr>
            <tr><td>A3</td><td>≥ 3,8</td></tr>
            <tr><td>A4</td><td>≥ 3,5</td></tr>
            <tr><td>A5</td><td>≥ 3,2</td></tr>
            <tr><td>A6</td><td>≥ 2,9</td></tr>
            <tr><td>A7</td><td>≥ 2,6</td></tr>
            <tr><td>A8</td><td>≥ 2,3</td></tr>
            <tr><td>A9</td><td>&lt; 2,3</td></tr>
          </tbody>
        </table>
      </div>
      <p><em>* Los deportistas que superen una media de 5 W/kg quedarán excluidos de las clasificaciones.</em></p>

      <h3>Categorías de edad:</h3>
      <div className="rmc-age-categories">
        <div className="rmc-age-col">
          <h4>HOMBRES</h4>
          <ul>
            <li>M1: 17–29 años</li>
            <li>M2: 30–39 años</li>
            <li>M3: 40–49 años</li>
            <li>M4: 50–59 años</li>
            <li>M5: 60–64 años</li>
            <li>M6: 65–69 años</li>
            <li>M7: 70–74 años</li>
            <li>M8: 75+ años</li>
          </ul>
        </div>
        <div className="rmc-age-col">
          <h4>MUJERES</h4>
          <ul>
            <li>W1: 17–29 años</li>
            <li>W2: 30–44 años</li>
            <li>W3: 45–59 años</li>
            <li>W4: 60+ años</li>
          </ul>
        </div>
      </div>
    </section>

    <section>
      <h2>4. REGLAMENTO TÉCNICO</h2>

      <h3>4.1. Rodillos inteligentes de clase A (permitidos en todas las categorías):</h3>
      <ul>
        <li><strong>Van Rysel:</strong> RCR</li>
        <li><strong>Wahoo:</strong> Kickr V5, Kickr V6, Kickr Move, Kickr Bike V1, Kickr Bike V2, Kickr Bike Shift, Kickr Core</li>
        <li><strong>Tacx:</strong> Neo, Neo 2T, Neo 3M, Neo Bike, Neo Bike Plus</li>
        <li><strong>Elite:</strong> Justo, Justo 2, Direto X, Direto XR, Direto XR-T, Avanti</li>
        <li><strong>Thinkrider:</strong> X7 pro, X2, X2 Max</li>
        <li><strong>Cycplus:</strong> T2, T7</li>
        <li><strong>APX:</strong> APX Pro, APXComp</li>
        <li><strong>Zycle:</strong> Zbike 2.0</li>
        <li><strong>WattBike Atom</strong></li>
      </ul>

      <h3>Rodillos inteligentes de clase B (permitidos en las categorías A5 a A9):</h3>
      <p>Todos los rodillos de clase A indicados arriba, más:</p>
      <ul>
        <li><strong>Tacx:</strong> Flux-S, Flux 2</li>
        <li><strong>Elite:</strong> Suito, Suito-T, Rampa, Rivo</li>
        <li><strong>Jet Black:</strong> Volt</li>
        <li><strong>ZDrive</strong></li>
      </ul>
      <p>Cualquier otro rodillo debe comunicarse al organizador para valorar su admisión antes del comienzo del campeonato.</p>

      <h3>Accesorios obligatorios:</h3>
      <ul>
        <li>Sensor de cadencia</li>
        <li>Pulsómetro</li>
        <li>Medidor de potencia procedente exclusivamente del rodillo y no de otras fuentes externas (Stages, pedales, la app QZ, etc.); en caso contrario el participante quedará excluido de la RMC.</li>
      </ul>

      <h3>4.2. Ajustes y configuración:</h3>
      <ul>
        <li><strong>Dificultad:</strong> los rodillos deben estar al 100 % de dificultad.</li>
        <li><strong>Firmware actualizado:</strong> es obligatorio tener la última versión publicada oficialmente (nada de betas).</li>
        <li><strong>Cambio de equipamiento:</strong> los participantes deben avisar de cualquier cambio de equipamiento con al menos 5 días de antelación.</li>
      </ul>
      <p>Si durante la carrera surge algún problema con el pulsómetro, la aplicación o el rodillo, hay que comunicarlo al organizador antes de que se elaboren las clasificaciones.</p>
    </section>

    <section>
      <h2>5. SANCIONES</h2>

      <h3>Conductas prohibidas e infracciones posibles:</h3>
      <ul>
        <li>Manipulación de datos o de dispositivos (por ejemplo, altura o peso falseados)</li>
        <li>Uso de equipamiento no conforme o no aprobado</li>
        <li>No llevar pulsómetro</li>
        <li>Rendimiento que no se puede verificar</li>
      </ul>

      <h3>Tipos de sanción:</h3>
      <ul>
        <li><strong>Primera infracción:</strong> penalización de tiempo</li>
        <li><strong>Segunda infracción:</strong> exclusión de la carrera en curso</li>
        <li><strong>Tercera infracción:</strong> descalificación del campeonato</li>
      </ul>
    </section>

    <section>
      <h2>6. NOTAS FINALES</h2>
      <p><strong>Comprobaciones cruzadas:</strong> los organizadores pueden pedir datos externos (como BikeCalculator) para verificar rendimientos anómalos.</p>
      <p><strong>Comunidad activa:</strong> se recomienda unirse a los grupos oficiales de Facebook y Telegram para estar al día en tiempo real.</p>
    </section>

  </div>
);

// Регламент на французском: те же разделы, что в остальных переводах
const RMCRulesContentFr = () => (
  <div className="rmc-rules-content">

    <section>
      <h2>1. INTRODUCTION</h2>
      <p>Le Rouvy Mamiky's Championship (RMC) est une compétition de cyclisme indoor disputée sur la plateforme virtuelle Rouvy et ouverte aux amateurs et aux passionnés du monde entier. Le championnat se déroule du 2 novembre 2026 au 31 mars 2027 ; il vise à promouvoir le sport grâce aux technologies immersives et à favoriser les échanges entre les participants par des compétitions hebdomadaires garantissant liberté de participation et inclusion.</p>

      <h3>Conditions d'inscription :</h3>
      <p>Pour participer, il faut :</p>
      <p><strong>Demande d'ami sur Rouvy :</strong> chaque coureur doit envoyer ou confirmer une demande de connexion à mamiky sur Rouvy, afin de permettre le suivi et le traitement des données de course.</p>
    </section>

    <section>
      <h2>2. STRUCTURE DU CHAMPIONNAT</h2>

      <h3>2.1. Durée :</h3>
      <p>Du 2 novembre 2026 au 28 mars 2027</p>
      <p>L'ensemble du championnat se divise en quatre courses mensuelles, avec des parcours propres à chaque course (Trentino Marathon…Slovenia Marathon…), avec des classements par catégorie et des classements généraux pour ces quatre courses, ainsi qu'un classement final spécial de toute la RMC, réservé à ceux qui disputent toutes les courses mensuelles.</p>

      <h3>2.2. Comment participer aux courses :</h3>
      <p><strong>Courses hebdomadaires officielles :</strong></p>
      <p>Deux courses officielles ont lieu chaque semaine :</p>
      <ul>
        <li><strong>Mercredi :</strong> à 08h15, 12h15, 16h15, 18h15 et 20h15 CET</li>
        <li><strong>Jeudi :</strong> à 08h45, 12h45, 16h45, 18h45 et 20h45 CET</li>
      </ul>

      <h3>2.3. Format de la compétition :</h3>
      <p><strong>Catégories de course :</strong></p>
      <p>Les courses se disputeront sur des parcours AR (réalité augmentée) et non AR, avec ou sans aspiration (autorisée ou non). Chaque particularité sera annoncée à l'avance dans le calendrier des courses.</p>
      <p>Outre les courses individuelles, des contre-la-montre par équipes (avec aspiration) et des contre-la-montre individuels (sans aspiration) seront organisés.</p>

      <p><strong>Vélos autorisés :</strong></p>
      <ul>
        <li>Seuls les vélos de route sont autorisés dans les courses officielles (les vélos de contre-la-montre sont remplacés automatiquement).</li>
        <li>Dans les contre-la-montre sans aspiration, les vélos de contre-la-montre sont autorisés.</li>
        <li>Le mode « JUST RIDE » est strictement interdit pendant les courses.</li>
      </ul>

      <h3>2.4. Wild cards :</h3>
      <p>Chaque coureur dispose de 5 wild cards pendant le championnat, utilisables pour créer une course supplémentaire à la date et à l'heure de son choix, selon ses besoins.</p>
    </section>

    <section>
      <h2>3. CLASSEMENTS</h2>

      <h3>3.1. Classement général :</h3>
      <p>Classement aux points.</p>

      <h3>3.2. Classements par catégorie :</h3>
      <p>Le classement et l'attribution de la catégorie (W/kg) reposeront sur le calcul des watts/kg moyens, établis exclusivement à partir des courses test de novembre (Trentino Marathon) et de certaines courses qui se dérouleront sans aspiration ou en mode non AR.</p>

      <div className="rmc-categories-table">
        <table>
          <thead>
            <tr><th>Catégorie</th><th>W/kg</th></tr>
          </thead>
          <tbody>
            <tr><td>ELITE</td><td>≥ 4,7</td></tr>
            <tr><td>A1</td><td>≥ 4,4</td></tr>
            <tr><td>A2</td><td>≥ 4,1</td></tr>
            <tr><td>A3</td><td>≥ 3,8</td></tr>
            <tr><td>A4</td><td>≥ 3,5</td></tr>
            <tr><td>A5</td><td>≥ 3,2</td></tr>
            <tr><td>A6</td><td>≥ 2,9</td></tr>
            <tr><td>A7</td><td>≥ 2,6</td></tr>
            <tr><td>A8</td><td>≥ 2,3</td></tr>
            <tr><td>A9</td><td>&lt; 2,3</td></tr>
          </tbody>
        </table>
      </div>
      <p><em>* Les athlètes dépassant une moyenne de 5 W/kg seront exclus des classements.</em></p>

      <h3>Catégories d'âge :</h3>
      <div className="rmc-age-categories">
        <div className="rmc-age-col">
          <h4>HOMMES</h4>
          <ul>
            <li>M1 : 17–29 ans</li>
            <li>M2 : 30–39 ans</li>
            <li>M3 : 40–49 ans</li>
            <li>M4 : 50–59 ans</li>
            <li>M5 : 60–64 ans</li>
            <li>M6 : 65–69 ans</li>
            <li>M7 : 70–74 ans</li>
            <li>M8 : 75 ans et plus</li>
          </ul>
        </div>
        <div className="rmc-age-col">
          <h4>FEMMES</h4>
          <ul>
            <li>W1 : 17–29 ans</li>
            <li>W2 : 30–44 ans</li>
            <li>W3 : 45–59 ans</li>
            <li>W4 : 60 ans et plus</li>
          </ul>
        </div>
      </div>
    </section>

    <section>
      <h2>4. RÈGLEMENT TECHNIQUE</h2>

      <h3>4.1. Home-trainers connectés de classe A (autorisés dans toutes les catégories) :</h3>
      <ul>
        <li><strong>Van Rysel :</strong> RCR</li>
        <li><strong>Wahoo :</strong> Kickr V5, Kickr V6, Kickr Move, Kickr Bike V1, Kickr Bike V2, Kickr Bike Shift, Kickr Core</li>
        <li><strong>Tacx :</strong> Neo, Neo 2T, Neo 3M, Neo Bike, Neo Bike Plus</li>
        <li><strong>Elite :</strong> Justo, Justo 2, Direto X, Direto XR, Direto XR-T, Avanti</li>
        <li><strong>Thinkrider :</strong> X7 pro, X2, X2 Max</li>
        <li><strong>Cycplus :</strong> T2, T7</li>
        <li><strong>APX :</strong> APX Pro, APXComp</li>
        <li><strong>Zycle :</strong> Zbike 2.0</li>
        <li><strong>WattBike Atom</strong></li>
      </ul>

      <h3>Home-trainers connectés de classe B (autorisés pour les catégories A5 à A9) :</h3>
      <p>Tous les home-trainers de classe A ci-dessus, plus :</p>
      <ul>
        <li><strong>Tacx :</strong> Flux-S, Flux 2</li>
        <li><strong>Elite :</strong> Suito, Suito-T, Rampa, Rivo</li>
        <li><strong>Jet Black :</strong> Volt</li>
        <li><strong>ZDrive</strong></li>
      </ul>
      <p>Tout autre home-trainer doit être signalé à l'organisateur pour évaluation de son admissibilité avant le début du championnat.</p>

      <h3>Accessoires obligatoires :</h3>
      <ul>
        <li>Capteur de cadence</li>
        <li>Cardiofréquencemètre</li>
        <li>Mesure de puissance provenant exclusivement du home-trainer et non d'autres sources externes (Stages, pédales, application QZ, etc.), faute de quoi le participant sera exclu de la RMC.</li>
      </ul>

      <h3>4.2. Réglages et configuration :</h3>
      <ul>
        <li><strong>Difficulté :</strong> les home-trainers doivent être réglés sur 100 % de difficulté.</li>
        <li><strong>Firmware à jour :</strong> il est obligatoire d'avoir la dernière version publiée officiellement (pas de bêta).</li>
        <li><strong>Changement de matériel :</strong> tout changement de matériel doit être signalé au moins 5 jours à l'avance.</li>
      </ul>
      <p>En cas de problème avec le cardiofréquencemètre, l'application ou le home-trainer pendant la course, il faut le signaler à l'organisateur avant l'établissement des classements.</p>
    </section>

    <section>
      <h2>5. SANCTIONS</h2>

      <h3>Comportements interdits et infractions possibles :</h3>
      <ul>
        <li>Manipulation des données ou des appareils (taille ou poids falsifiés, par exemple)</li>
        <li>Utilisation de matériel non conforme ou non homologué</li>
        <li>Absence de cardiofréquencemètre</li>
        <li>Performance impossible à vérifier</li>
      </ul>

      <h3>Types de sanctions :</h3>
      <ul>
        <li><strong>Première infraction :</strong> pénalité de temps</li>
        <li><strong>Deuxième infraction :</strong> exclusion de la course en cours</li>
        <li><strong>Troisième infraction :</strong> disqualification du championnat</li>
      </ul>
    </section>

    <section>
      <h2>6. REMARQUES FINALES</h2>
      <p><strong>Vérifications croisées :</strong> les organisateurs peuvent demander des données externes (comme BikeCalculator) pour vérifier des performances anormales.</p>
      <p><strong>Communauté active :</strong> il est recommandé de rejoindre les groupes officiels Facebook et Telegram pour suivre les nouvelles en temps réel.</p>
    </section>

  </div>
);

const RMCRulesContentCs = () => (
  <div className="rmc-rules-content">

    <section>
      <h2>1. ÚVOD</h2>
      <p>Rouvy Mamiky's Championship (RMC) je soutěž v indoor cyklistice pořádaná na virtuální platformě Rouvy, určená amatérům a nadšencům z celého světa. Šampionát probíhá od 2. listopadu 2026 do 31. března 2027 a jeho cílem je propagovat sport pomocí imerzivních technologií a podporovat kontakt mezi účastníky prostřednictvím týdenních soutěží, které zaručují svobodu účasti a otevřenost pro všechny.</p>

      <h3>Podmínky registrace:</h3>
      <p>Pro účast je nutné:</p>
      <p><strong>Žádost o přátelství na Rouvy:</strong> každý jezdec musí poslat nebo potvrdit žádost o spojení s uživatelem mamiky na Rouvy, aby bylo možné sledovat a zpracovávat data ze závodů.</p>
    </section>

    <section>
      <h2>2. STRUKTURA ŠAMPIONÁTU</h2>

      <h3>2.1. Doba trvání:</h3>
      <p>Od 2. listopadu 2026 do 28. března 2027</p>
      <p>Celý šampionát je rozdělen do čtyř měsíčních závodů, každý s vlastními trasami (Trentino Marathon…Slovenia Marathon…), s kategoriemi a celkovým pořadím pro tyto čtyři závody a se zvláštním konečným pořadím celého RMC, vyhrazeným pro ty, kdo se zúčastní všech měsíčních závodů.</p>

      <h3>2.2. Jak se účastnit závodů:</h3>
      <p><strong>Oficiální týdenní závody:</strong></p>
      <p>Každý týden se konají dva oficiální závody:</p>
      <ul>
        <li><strong>Středa:</strong> v 08:15, 12:15, 16:15, 18:15 a 20:15 SEČ</li>
        <li><strong>Čtvrtek:</strong> v 08:45, 12:45, 16:45, 18:45 a 20:45 SEČ</li>
      </ul>

      <h3>2.3. Formát soutěže:</h3>
      <p><strong>Kategorie závodů:</strong></p>
      <p>Závody se pojedou na trasách AR (rozšířená realita) i bez AR, s draftingem nebo bez něj (drafting povolen či nepovolen). Každá specifikace bude předem oznámena v kalendáři závodů.</p>
      <p>Kromě individuálních závodů se uskuteční týmové časovky (s draftingem) a individuální časovky (bez draftingu).</p>

      <p><strong>Povolená kola:</strong></p>
      <ul>
        <li>V oficiálních závodech jsou povolena pouze silniční kola (časovkářská kola budou automaticky nahrazena).</li>
        <li>V časovkách bez draftingu jsou časovkářská kola povolena.</li>
        <li>Režim „JUST RIDE“ je během závodů přísně zakázán.</li>
      </ul>

      <h3>2.4. Divoké karty:</h3>
      <p>Každý jezdec má během šampionátu k dispozici 5 divokých karet, které může využít k vytvoření dodatečného závodu s datem a časem podle vlastní volby a potřeb.</p>
    </section>

    <section>
      <h2>3. POŘADÍ</h2>

      <h3>3.1. Celkové pořadí:</h3>
      <p>Pořadí podle bodů.</p>

      <h3>3.2. Pořadí podle kategorií:</h3>
      <p>Zařazení a stanovení kategorie (W/kg) bude vycházet z výpočtu průměrných wattů na kilogram výhradně z listopadových testovacích závodů (Trentino Marathon) a z některých závodů, které se pojedou bez draftingu nebo v režimu bez AR.</p>

      <div className="rmc-categories-table">
        <table>
          <thead>
            <tr><th>Kategorie</th><th>W/kg</th></tr>
          </thead>
          <tbody>
            <tr><td>ELITE</td><td>≥ 4,7</td></tr>
            <tr><td>A1</td><td>≥ 4,4</td></tr>
            <tr><td>A2</td><td>≥ 4,1</td></tr>
            <tr><td>A3</td><td>≥ 3,8</td></tr>
            <tr><td>A4</td><td>≥ 3,5</td></tr>
            <tr><td>A5</td><td>≥ 3,2</td></tr>
            <tr><td>A6</td><td>≥ 2,9</td></tr>
            <tr><td>A7</td><td>≥ 2,6</td></tr>
            <tr><td>A8</td><td>≥ 2,3</td></tr>
            <tr><td>A9</td><td>&lt; 2,3</td></tr>
          </tbody>
        </table>
      </div>
      <p><em>* Sportovci s průměrem nad 5 W/kg budou z pořadí vyřazeni.</em></p>

      <h3>Věkové kategorie:</h3>
      <div className="rmc-age-categories">
        <div className="rmc-age-col">
          <h4>MUŽI</h4>
          <ul>
            <li>M1: 17–29 let</li>
            <li>M2: 30–39 let</li>
            <li>M3: 40–49 let</li>
            <li>M4: 50–59 let</li>
            <li>M5: 60–64 let</li>
            <li>M6: 65–69 let</li>
            <li>M7: 70–74 let</li>
            <li>M8: 75+ let</li>
          </ul>
        </div>
        <div className="rmc-age-col">
          <h4>ŽENY</h4>
          <ul>
            <li>W1: 17–29 let</li>
            <li>W2: 30–44 let</li>
            <li>W3: 45–59 let</li>
            <li>W4: 60+ let</li>
          </ul>
        </div>
      </div>
    </section>

    <section>
      <h2>4. TECHNICKÁ PRAVIDLA</h2>

      <h3>4.1. Chytré trenažéry třídy A (povoleny pro všechny kategorie):</h3>
      <ul>
        <li><strong>Van Rysel:</strong> RCR</li>
        <li><strong>Wahoo:</strong> Kickr V5, Kickr V6, Kickr Move, Kickr Bike V1, Kickr Bike V2, Kickr Bike Shift, Kickr Core</li>
        <li><strong>Tacx:</strong> Neo, Neo 2T, Neo 3M, Neo Bike, Neo Bike Plus</li>
        <li><strong>Elite:</strong> Justo, Justo 2, Direto X, Direto XR, Direto XR-T, Avanti</li>
        <li><strong>Thinkrider:</strong> X7 pro, X2, X2 Max</li>
        <li><strong>Cycplus:</strong> T2, T7</li>
        <li><strong>APX:</strong> APX Pro, APXComp</li>
        <li><strong>Zycle:</strong> Zbike 2.0</li>
        <li><strong>WattBike Atom</strong></li>
      </ul>

      <h3>Chytré trenažéry třídy B (povoleny pro kategorie A5 až A9):</h3>
      <p>Všechny výše uvedené trenažéry třídy A a navíc:</p>
      <ul>
        <li><strong>Tacx:</strong> Flux-S, Flux 2</li>
        <li><strong>Elite:</strong> Suito, Suito-T, Rampa, Rivo</li>
        <li><strong>Jet Black:</strong> Volt</li>
        <li><strong>ZDrive</strong></li>
      </ul>
      <p>Jakékoli jiné trenažéry je nutné před začátkem šampionátu nahlásit organizátorovi k posouzení způsobilosti.</p>

      <h3>Povinné příslušenství:</h3>
      <ul>
        <li>Snímač kadence</li>
        <li>Snímač srdečního tepu</li>
        <li>Měření výkonu výhradně z trenažéru, nikoli z jiných externích zdrojů (Stages, pedály, QZ App atd.); v opačném případě bude účastník z RMC vyloučen.</li>
      </ul>

      <h3>4.2. Nastavení a konfigurace:</h3>
      <ul>
        <li><strong>Obtížnost:</strong> trenažéry musí být nastaveny na 100% obtížnost.</li>
        <li><strong>Aktuální firmware:</strong> povinná je nejnovější oficiálně vydaná verze (ne beta).</li>
        <li><strong>Změna vybavení:</strong> účastníci musí jakoukoli změnu vybavení oznámit alespoň 5 dní předem.</li>
      </ul>
      <p>Jakékoli problémy se snímačem tepu, aplikací nebo trenažérem během závodu je nutné nahlásit organizátorovi před sestavením pořadí.</p>
    </section>

    <section>
      <h2>5. TRESTY</h2>

      <h3>Zakázané jednání a možná porušení:</h3>
      <ul>
        <li>Manipulace s daty nebo zařízeními (např. zkreslená výška/hmotnost)</li>
        <li>Používání nevyhovujícího nebo neschváleného vybavení</li>
        <li>Jízda bez snímače srdečního tepu</li>
        <li>Výkony, které nelze ověřit</li>
      </ul>

      <h3>Druhy trestů:</h3>
      <ul>
        <li><strong>První porušení:</strong> časová penalizace</li>
        <li><strong>Druhé porušení:</strong> vyloučení z aktuálního závodu</li>
        <li><strong>Třetí porušení:</strong> diskvalifikace ze šampionátu</li>
      </ul>
    </section>

    <section>
      <h2>6. ZÁVĚREČNÉ POZNÁMKY</h2>
      <p><strong>Křížové kontroly:</strong> organizátoři si mohou k ověření neobvyklých výkonů vyžádat externí data (např. BikeCalculator).</p>
      <p><strong>Interaktivní komunita:</strong> doporučujeme připojit se k oficiálním skupinám na Facebooku a Telegramu, kde najdete aktuální informace v reálném čase.</p>
    </section>

  </div>
);

const RMCRules = () => {
  const navigate = useNavigate();
  const { t, language } = useLanguage();

  return (
    <div className="rmc-rules-page">
      <div className="rmc-rules-container">
        <button className="rmc-back-btn" onClick={() => navigate('/rmc')}>
          ← {t('rmc.rules.backToDashboard')}
        </button>

        <div className="rmc-rules-header">
          <h1>{t('rmc.rules.title')}</h1>
          <p className="rmc-rules-subtitle">{t('rmc.rules.subtitle')}</p>
          <p className="rmc-rules-version">{t('rmc.rules.version')}</p>
        </div>

        {language === 'it' && <RMCRulesContentIt />}
        {language === 'de' && <RMCRulesContentDe />}
        {language === 'es' && <RMCRulesContentEs />}
        {language === 'fr' && <RMCRulesContentFr />}
        {language === 'cs' && <RMCRulesContentCs />}
        {!['it', 'de', 'es', 'fr', 'cs'].includes(language) && (
        <div className="rmc-rules-content">

          <section>
            <h2>1. INTRODUCTION</h2>
            <p>The Rouvy Mamiky's Championship (RMC) is an indoor cycling competition held on the Rouvy virtual platform, aimed at amateurs and enthusiasts worldwide. The championship runs from 2 November 2026 to 31 March 2027, with the aim of promoting the sport through the use of immersive technologies and fostering interaction among participants via weekly competitions that ensure freedom of participation and inclusion.</p>

            <h3>Registration requirements:</h3>
            <p>To participate, the following is required:</p>
            <p><strong>Friend request on Rouvy:</strong> Each rider must send or confirm a connection request to mamiky on Rouvy, in order to enable the tracking and processing of race data.</p>
          </section>

          <section>
            <h2>2. CHAMPIONSHIP STRUCTURE</h2>

            <h3>2.1. Duration:</h3>
            <p>From 2 November 2026 to 28 March 2027</p>
            <p>The entire Championship is divided into four monthly races, with routes specific to each race (Trentino Marathon…Slovenia Marathon…), featuring category and overall rankings for those four races, and a special final ranking for the entire RMC, reserved for those who compete in all the monthly races.</p>

            <h3>2.2. How to participate in races:</h3>
            <p><strong>Official weekly races:</strong></p>
            <p>Two official races take place each week:</p>
            <ul>
              <li><strong>Wednesday:</strong> at 08:15, 12:15, 16:15, 18:15, 20:15 CET</li>
              <li><strong>Thursday:</strong> at 08:45, 12:45, 16:45, 18:45, 20:45 CET</li>
            </ul>

            <h3>2.3. Competition format:</h3>
            <p><strong>Race categories:</strong></p>
            <p>Races will be held on AR (Augmented Reality) and non-AR routes, with or without drafting (drafting permitted or not). Each specification will be announced in advance in the race calendar.</p>
            <p>In addition to individual races, Team Time Trials (with drafting) and Individual Time Trials (without drafting) will be organised.</p>

            <p><strong>Eligible bike specifications:</strong></p>
            <ul>
              <li>Only road bikes are permitted for official races (Time Trial bikes will be automatically replaced).</li>
              <li>In time trials without drafting, Time Trial bikes will be permitted.</li>
              <li>The "JUST RIDE" mode is strictly prohibited during races.</li>
            </ul>

            <h3>2.4. Wild Cards:</h3>
            <p>Each rider has 5 Wild Cards available during the Championship, which can be used to create an Extra Race, with a date and time of their choosing, according to their needs.</p>
          </section>

          <section>
            <h2>3. CLASSIFICATIONS</h2>

            <h3>3.1. Overall Classification:</h3>
            <p>Points-based classification.</p>

            <h3>3.2. Category classifications:</h3>
            <p>The classification and assessment of the Category (W/kg) will be based on the calculation of the average Watts/kg, relating exclusively to the November Test Races (Trentino Marathon) and to some races that will take place without drafting or in non-AR mode.</p>

            <div className="rmc-categories-table">
              <table>
                <thead>
                  <tr><th>Category</th><th>W/kg</th></tr>
                </thead>
                <tbody>
                  <tr><td>ELITE</td><td>≥ 4.7</td></tr>
                  <tr><td>A1</td><td>≥ 4.4</td></tr>
                  <tr><td>A2</td><td>≥ 4.1</td></tr>
                  <tr><td>A3</td><td>≥ 3.8</td></tr>
                  <tr><td>A4</td><td>≥ 3.5</td></tr>
                  <tr><td>A5</td><td>≥ 3.2</td></tr>
                  <tr><td>A6</td><td>≥ 2.9</td></tr>
                  <tr><td>A7</td><td>≥ 2.6</td></tr>
                  <tr><td>A8</td><td>≥ 2.3</td></tr>
                  <tr><td>A9</td><td>&lt; 2.3</td></tr>
                </tbody>
              </table>
            </div>
            <p><em>* Athletes exceeding an average of 5 W/kg will be excluded from the rankings.</em></p>

            <h3>Age categories:</h3>
            <div className="rmc-age-categories">
              <div className="rmc-age-col">
                <h4>MEN</h4>
                <ul>
                  <li>M1: 17–29 years</li>
                  <li>M2: 30–39 years</li>
                  <li>M3: 40–49 years</li>
                  <li>M4: 50–59 years</li>
                  <li>M5: 60–64 years</li>
                  <li>M6: 65–69 years</li>
                  <li>M7: 70–74 years</li>
                  <li>M8: 75+ years</li>
                </ul>
              </div>
              <div className="rmc-age-col">
                <h4>WOMEN</h4>
                <ul>
                  <li>W1: 17–29 years</li>
                  <li>W2: 30–44 years</li>
                  <li>W3: 45–59 years</li>
                  <li>W4: 60+ years</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2>4. TECHNICAL REGULATIONS</h2>

            <h3>4.1. Class-A Smart Trainers (permitted for all categories):</h3>
            <ul>
              <li><strong>Van Rysel:</strong> RCR</li>
              <li><strong>Wahoo:</strong> Kickr V5, Kickr V6, Kickr Move, Kickr Bike V1, Kickr Bike V2, Kickr Bike Shift, Kickr Core</li>
              <li><strong>Tacx:</strong> Neo, Neo 2T, Neo 3M, Neo Bike, Neo Bike Plus</li>
              <li><strong>Elite:</strong> Justo, Justo 2, Direto X, Direto XR, Direto XR-T, Avanti</li>
              <li><strong>Thinkrider:</strong> X7 pro, X2, X2 Max</li>
              <li><strong>Cycplus:</strong> T2, T7</li>
              <li><strong>APX:</strong> APX Pro, APXComp</li>
              <li><strong>Zycle:</strong> Zbike 2.0</li>
              <li><strong>WattBike Atom</strong></li>
            </ul>

            <h3>Class-B Smart Trainers (permitted for Categories from A5 to A9):</h3>
            <p>All Class-A trainers listed above, plus:</p>
            <ul>
              <li><strong>Tacx:</strong> Flux-S, Flux 2</li>
              <li><strong>Elite:</strong> Suito, Suito-T, Rampa, Rivo</li>
              <li><strong>Jet Black:</strong> Volt</li>
              <li><strong>ZDrive</strong></li>
            </ul>
            <p>Any other trainers must be notified to the organiser for eligibility assessment prior to the start of the championship.</p>

            <h3>Mandatory accessories:</h3>
            <ul>
              <li>Cadence sensor</li>
              <li>Heart rate monitor</li>
              <li>Power meter deriving exclusively from the trainer and not from other external sources (Stages, Pedals, QZ App, etc.), failing which the participant will be excluded from the RMC.</li>
            </ul>

            <h3>4.2. Settings and configuration:</h3>
            <ul>
              <li><strong>Difficulty:</strong> Trainers must be set to 100% difficulty.</li>
              <li><strong>Updated firmware:</strong> It is mandatory to have the latest officially released version (no beta).</li>
              <li><strong>Change of equipment:</strong> Participants must give at least 5 days' notice of any change of equipment.</li>
            </ul>
            <p>In the event of any problems with the heart rate monitor, app or trainer during the race, this must be reported to the organiser before the rankings are drawn up.</p>
          </section>

          <section>
            <h2>5. PENALTIES</h2>

            <h3>Prohibited conduct and potential violations:</h3>
            <ul>
              <li>Tampering with data or devices (e.g. falsified height/weight)</li>
              <li>Use of non-compliant or unapproved equipment</li>
              <li>Failure to wear a heart rate monitor</li>
              <li>Performance that cannot be verified</li>
            </ul>

            <h3>Types of penalties:</h3>
            <ul>
              <li><strong>First violation:</strong> Time penalty</li>
              <li><strong>Second violation:</strong> Exclusion from the current race</li>
              <li><strong>Third violation:</strong> Disqualification from the championship</li>
            </ul>
          </section>

          <section>
            <h2>6. FINAL NOTES</h2>
            <p><strong>Cross-checks:</strong> Organisers may request external data (such as BikeCalculator) to verify anomalous performance.</p>
            <p><strong>Interactive community:</strong> It is recommended to join the official Facebook and Telegram groups for real-time updates.</p>
          </section>

        </div>
        )}

        <div className="rmc-rules-footer">
          <button className="btn btn-primary" onClick={() => navigate('/rmc')}>
            ← {t('rmc.rules.backToDashboard')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RMCRules;
